var _rect, _mask, _rect2, _rect3, _rect4, _g, _ellipse;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDealLayoutC1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 19,
    viewBox: "0 0 23 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 18,
    rx: 1.5,
    stroke: "current"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_11577_9861",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.11108,
    width: 19,
    height: 2.11111,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2.11108,
    width: 19,
    height: 2.11111,
    rx: 1,
    stroke: "current",
    strokeWidth: 2.11111,
    mask: "url(#path-2-inside-1_11577_9861)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 5.77783,
    width: 18,
    height: 10.6111,
    rx: 1.5,
    stroke: "current"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_11577_9861",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 5,
    width: 19,
    height: 11
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 5.27783,
    width: 19,
    height: 10.5556,
    rx: 2,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_11577_9861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.7212 14.9384C2.49197 15.0924 2.43097 15.403 2.58494 15.6323C2.73892 15.8615 3.04957 15.9225 3.2788 15.7685L2.7212 14.9384ZM8 11.9949L8.25717 11.5661L7.98482 11.4027L7.7212 11.5798L8 11.9949ZM12 14.3939L11.7428 14.8227L12.038 14.9997L12.3088 14.7871L12 14.3939ZM17.5 10.0757L17.7861 9.66566L17.4825 9.45374L17.1912 9.68241L17.5 10.0757ZM3.2788 15.7685L8.2788 12.4099L7.7212 11.5798L2.7212 14.9384L3.2788 15.7685ZM7.74283 12.4237L11.7428 14.8227L12.2572 13.9651L8.25717 11.5661L7.74283 12.4237ZM12.3088 14.7871L17.8088 10.469L17.1912 9.68241L11.6912 14.0006L12.3088 14.7871ZM17.2139 10.4857L22.7139 14.3241L23.2861 13.504L17.7861 9.66566L17.2139 10.4857Z",
    fill: "current"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 12,
    cy: 9.50001,
    rx: 1,
    ry: 1.05556,
    stroke: "current",
    strokeWidth: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealLayoutC1);
export default __webpack_public_path__ + "static/media/DealLayoutC_1.8849c79e62949e2cf68ca6e908cffdc2.svg";
export { ForwardRef as ReactComponent };